import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'

import VueCordovaDevice from 'vue-cordova-device'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Notifications from 'vue-notification'
import VueCordova from 'vue-cordova'
import Tap from 'vtap'
Vue.config.productionTip = false;

Vue.use(VueCordova);
Vue.use(VueCordovaDevice);
Vue.use(Notifications);
Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(Tap);

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}


import store from './store'

new Vue({
  render: h => h(App),
  store
}).$mount('#app');
